import axios, { type AxiosInstance } from "axios";
import { COMMON_HEADERS } from "./restApi";
import { RestFetchApi } from "./restFetchApi";
import { buildAxiosConfigWithHeaders, buildAxiosQueryConfigWithHeaders } from "./restApiRequestConfig";

import type { ApiClient, QueryParams, RequestHeaders } from "./restApi";

/** ApiClient that uses axios library underneath */
export class ApiClientAxios implements ApiClient {
    axiosInstance: AxiosInstance;
    fetchInstance: ApiClient;

    constructor() {
        this.axiosInstance = axios.create({
            headers: COMMON_HEADERS,
        });
        this.fetchInstance = new RestFetchApi();
    }

    get(url: string, params?: QueryParams, headers?: RequestHeaders): Promise<unknown> {
        const config = buildAxiosQueryConfigWithHeaders(params, headers);
        return this.axiosInstance.get(url, config);
    }

    post(url: string, body: unknown, headers?: RequestHeaders): Promise<unknown> {
        if (url.startsWith("/api/v1.0/reports/quick-simulation-sync")) {
            return this.fetchInstance.post(url, body, headers);
        }

        const config = buildAxiosConfigWithHeaders(headers);
        return this.axiosInstance.post(url, body, config);
    }

    put(url: string, body: unknown, headers?: RequestHeaders): Promise<unknown> {
        const config = buildAxiosConfigWithHeaders(headers);
        return this.axiosInstance.put(url, body, config);
    }

    delete(url: string, params?: QueryParams, headers?: RequestHeaders): Promise<unknown> {
        const config = buildAxiosQueryConfigWithHeaders(params, headers);
        return this.axiosInstance.delete(url, config);
    }

    setRequestHeader(key: string, val: string | null): void {
        // axios serializes default header values verbatim, so clearing a header
        // means removing the key instead of storing an empty/null value.
        if (val === null) {
            delete this.axiosInstance.defaults.headers.common[key];
        } else {
            this.axiosInstance.defaults.headers.common[key] = val;
        }
        this.fetchInstance.setRequestHeader(key, val);
    }

    /** Allow access to underlaying instance for setting interceptors */
    getAxiosInstance(): AxiosInstance {
        return this.axiosInstance;
    }

    abort(): void {
        if (this.fetchInstance) {
            this.fetchInstance.abort();
        }
    }
}
